import { toast } from 'react-toastify';

export class ToastService {

    static error(message: string, onOpen?: () => void): void {
        toast.error(message, { autoClose: 5000, hideProgressBar: true, onOpen});
    }

    static sucess(message: string): void {
        toast.success(message, {autoClose: 5000, hideProgressBar: true})
    }
}